import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from 'src/app/services/api/cart.service';
// import { FbpixelService } from 'src/app/services/api/fbpixel.service';
import { ProductService } from 'src/app/services/api/product.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { SessionService } from 'src/app/services/session.service';
import { WinService } from 'src/app/services/win.service';
import { Sizing } from "src/app/lib/sizing";

@Component({
  selector: 'app-product-t-shirt',
  templateUrl: './product-t-shirt.component.html',
  styleUrls: ['./product-t-shirt.component.scss']
})
export class ProductTShirtComponent implements OnInit {

	product: any;
	ytBlockId: any = 2;
	imageUrl: any;
	bg = "bg-red";
	headerClass: any = "bg-white";

	constructor(
		public winService: WinService,
		public router: Router,
		public _route: ActivatedRoute,
		public productService: ProductService,
		public lang: LangService,
		public sessionService: SessionService,
		public sanitizer: DomSanitizer,
		public cartService: CartService,
	) { }

	ngOnInit(): void {
		this.cartService.getCartId().then(quote_id => { /** --- */ });

		this._route.paramMap.subscribe((url_param) => {
			this.productService.setLoader(true);
			this.product = null;

			let sku = "custom-t-shirt";

			let _sku = this._route.url['_value'][this._route.url['_value'].length - 1]['path'];
			let regex = /^([a-zA-Z0-9_\-\.]+)\.html?$/;
			let match = _sku.match(regex);
			if (match) {
				sku = match[1];
			}
			
			if(sku == 'custom-canvas-tote-bag'){
				this.headerClass = 'bg-transparent';
			}
			else if(sku == 'custom-t-shirt'){
				this.headerClass = 'bg-white';
			}
			
			let url = "/rest/entrelable/V1/products/" + sku;
			this.productService.doRequest(url, '', 'GET').then((result:any) => {
				if(!result.error && result.result){
					this.product = result.result;
					if(typeof this.product.media_gallery_entries != 'undefined'){
						this.imageUrl = this.productService.getUrl("/media/catalog/product" + this.product.media_gallery_entries[0].file);
					}
				}
				this.productService.setLoader(false);
			});
		});
	}
}
